<template>
  <van-popup
    v-model="productsPopShow"
    round
    position="bottom"
    :safe-area-inset-bottom="true"
    :close-on-click-overlay="false"
    :style="{ height: '40%' }"
    closeable
    @close="handleClose"
  >
    <div class="product">
      <div class="product-title">为您匹配以下产品</div>
      <div v-for="(item, index) in productsPopData" :key="index" class="product-item">
        <div class="product-box">
          <div class="product-item-list-left">
            <div class="product-item-title">
              <img class="product-logo" :src="item.imgUrl" />
              <span>{{ item.productName }}</span>
              <template v-if="item.tagList">
                <van-tag
                  v-for="(i, idx) in item.tagList"
                  :key="idx"
                  :color="idx === 0 ? 'rgba(254, 247, 231, 1)' : 'rgba(255, 238, 234, 1)'"
                  :text-color="idx === 0 ? '#FD8400' : '#F5572F'"
                >
                  {{ i }}
                </van-tag>
              </template>
            </div>
            <!-- <div class="product-item-amount">为您授信<span>{{ item.creditAmount }}元</span>贷款额度</div> -->
            <div class="success-to">
              <div class="text">
                最高可借<span style="margin-right: 0.15rem">{{ item.maxAmount }}元</span>
                <!-- 合规调整：不再用“最低”口径突出产品利率。 -->
              </div>
            </div>
          </div>
          <div class="product-item-list-right">
            <div @click="handleGoLink(item)" class="go-to-detail">立即申请</div>
            <!-- <div class="list-first-btn" @click="handleGoLink(recommendProduct)">立即申请</div> -->
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>
<script>
import * as API_Common from '@/api/common.js'
import { formatAppFrameLinkUrl } from '@/utils/appFrameUrl.js'
export default {
  name: 'recommendProducts',
  props: {
    productsPopShow: {
      type: Boolean,
      default: false,
    },
    productsPopData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'productsPop'
  },
  methods: {
    handleClose() {
      setTimeout(() => {
        const source = this.$route.query.source
        let timestamp = new Date().getTime()
        // 如果是贷超流程则直接跳转贷超列表
        if (source === 'renpinjiekuan') {
          window.location.href = `/productListTl3.html?source=${this.$route.query.source}&tsp=${timestamp}`
        } else if (source === 'huiyihua') {
          window.location.href = `/productListSjh.html?source=${this.$route.query.source}&tsp=${timestamp}`
        } else if (source === 'yangxiaomie') {
          window.location.href = `/productListCchjq.html?source=${this.$route.query.source}&tsp=${timestamp}`
        } else if (source === 'sjhreview') {
          window.location.href = `/productListSjh2.html?source=${this.$route.query.source}&tsp=${timestamp}`
        } else {
          window.location.href = `/productListOrange.html?source=${this.$route.query.source}&tsp=${timestamp}`
        }
      }, 500)
    },

    // 跳转
    handleGoLink(item) {
      if (item.checkMobileStatus != 0) {
        API_Common.handleBatchTrackBase(20701)
        setTimeout(() => {
          window.location.href = `/productDetail?productId=${item.productId}&showPage=22&source=${this.$route.query.source}`
        }, 1000)
      } else {
        API_Common.handleBatchTrackBase(20702)
        API_Common.buried({
          productId: item.productId,
          showPage: 22,
        })
          .then((res) => {
            const productId = res.data.productId || item.productId
            window.location.href =
              '/appFrame?productId=' + productId + '&url=' + formatAppFrameLinkUrl(res.data.linkUrl)
            sessionStorage.setItem('lastUrl', window.location.href)
          })
          .catch((error) => {
            console.error('产品实时校验失败', error)
          })
      }
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
</script>
<style lang="scss" scoped>
.product {
  padding-top: 1rem;
  .product-title {
    padding: 0 0.2rem;
    margin-bottom: 0.2rem;
    font-size: 0.3rem;
  }
  .product-item {
    padding: 0 0.2rem;
    .product-box {
      padding: 0 0.1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 0.02rem solid #e8e8e8;
      border-radius: 0.1rem;
      margin-bottom: 0.2rem;
      .product-logo {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.12rem;
        border-radius: 0.08rem;
      }

      .product-item-title {
        font-size: 0.3rem;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        color: #111c31;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }

      .product-item-title > span:first-child {
        margin-right: 0.01rem;
        line-height: 0.6rem;
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 0.28rem;
        color: #1c1c1c;
        line-height: 0.4rem;
      }

      .product-item-title .van-tag {
        margin-left: 0.1rem;
        font-size: 0.21rem;
        font-weight: 400;
        font-family: PingFangSC, PingFangSC-Regular;
        padding: 0.05rem 0.08rem 0.05rem 0.07rem;
        border-radius: 0.04rem;
        /* vertical-align: text-top; */
        font-family: PingFangSC, PingFang SC;
        color: #fd8400;
        line-height: 0.3rem;
      }

      .product-item-amount {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #858585;
      }

      .product-item-amount > span {
        color: #f03d23;
      }

      .product-item-middle {
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #858585;
        border-bottom: 0.02rem solid #e8e8e8;
        padding-top: 0.44rem;
        padding-bottom: 0.36rem;
      }

      .product-item-middle h5 {
        font-size: 0.4rem;
        font-weight: 400;
        font-family: Roboto, Roboto;
        font-weight: normal;
        line-height: 0.47rem;
        margin-bottom: 0.05rem;
      }

      .product-item-list-left {
        margin-top: 0.4rem;
      }
      .success-to {
        margin: 0.15rem 0 0.4rem 0;
      }

      .success-to .text {
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #858585;
        line-height: 0.33rem;
        position: relative;
      }

      .success-to .text > span {
        color: #e71a0f;
      }

      /* 列表右侧按钮 */

      .product-item-list-right .go-to-detail {
        width: 1.76rem;
        height: 0.62rem;
        line-height: 0.62rem;
        font-family: PingFangSC, PingFang SC;
        font-size: 0.28rem;
        border-radius: 0.3rem;
        border: 0.01rem solid #2d60f2;
        background-color: #1c74f0;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

/* 下拉刷新样式重写 */
.van-pull-refresh__head,
.van-list__loading,
.van-loading__text,
.van-loading__spinner {
  font-size: 0.28rem;
  color: #868e9e !important;
  margin-top: -0.12rem;
  line-height: 0.7rem;
}

.van-pull-refresh__head {
  margin-top: 0.5rem;
}

.downAppUrl {
  width: 100%;
  height: 2.16rem;
  background-color: #fff;
  position: fixed;
  left: 0rem;
  right: 0rem;
  bottom: 0rem;
  padding: 0.45rem 0.66rem 0.73rem;
}

.downAppUrl .downAppUrl-tip {
  font-size: 12px;
  color: #858585;
  text-align: center;
  margin-top: 2px;
}

.downAppUrlBtn {
  width: 100%;
  height: 0.98rem;
  background: #e71a0f;
  box-shadow: 0rem 0.06rem 0.14rem 0rem rgba(252, 43, 30, 0.29);
  border-radius: 0.51rem;
  display: block;
  border: none;
}

.downAppUrlBtn .van-button__content .van-button__text {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 0.34rem;
  color: #ffffff;
  line-height: 0.48rem;
}
</style>
